import ErrorBoundary from '@shared/components/ErrorBoundaries/ErrorBoundary';
import useContent from '@shared/queries/useContent';

import { AuctionsPromoGroup } from '../../types';
import Slider from './generic-slider';

export default function PromotionsSlider() {
    const { data, isSuccess } = useContent<AuctionsPromoGroup>({
        contentType: 'auctionsPromotionGroup',
    });

    // return empty if data is not loaded
    if (!isSuccess || !data?.[0]?.fields) {
        return <></>;
    }

    const content = data[0].fields;
    const promotions = content.promotionItems.filter(item => item.fields).map(item => item.fields);

    return (
        <ErrorBoundary fallback={<></>}>
            <div data-testid="promotions-slider" className="promotions-slider">
                <div className="promotions-slider-title">
                    <h2 className="kmx-typography--display-6">{content.sectionTitle}</h2>
                </div>
                <div className="container">
                    {data != undefined && <Slider promotions={promotions} />}
                </div>
            </div>
        </ErrorBoundary>
    );
}
